import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { WidgetModule } from "./widget/widget.module";
import { PagetitleComponent } from "./pagetitle/pagetitle.component";
import { PageHeaderComponent } from "./page-header/page-header.component";
import { PageHeaderWithButtonComponent } from "./page-header-with-button/page-header-with-button.component";
import { CardSummaryComponent } from "./card-summary/card-summary.component";
import { NgbToastModule } from "@ng-bootstrap/ng-bootstrap";
import { ToastsContainer } from "./toasts/toasts-container.component";
import { StatusCorFormatterPipe } from "./pipes/status-cor/status-cor-formatter.pipe";
import { NoAccessComponent } from "./no-access/no-access/no-access.component";
import { ErrorMessagesService } from "./messages/services/error-messages.service";
import { TourButtonComponent } from "./tour-button/tour-button.component";
import { HelpTourButtonComponent } from "./help-tour-button/help-tour-button.component";

@NgModule({
  declarations: [ToastsContainer, PagetitleComponent, PageHeaderComponent, PageHeaderWithButtonComponent, StatusCorFormatterPipe, NoAccessComponent, TourButtonComponent, HelpTourButtonComponent, CardSummaryComponent],
  providers: [ErrorMessagesService],
  imports: [CommonModule, WidgetModule, NgbToastModule],
  exports: [PagetitleComponent, PageHeaderComponent, PageHeaderWithButtonComponent, ToastsContainer, StatusCorFormatterPipe, NoAccessComponent, TourButtonComponent, HelpTourButtonComponent, CardSummaryComponent],
})
export class SharedModule {}
